var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-3 mb-2",staticStyle:{"font-size":"10px"}},_vm._l((_vm.item.tags),function(tag,index){return _c('span',{key:index},[_c('v-chip',{staticClass:"mr-1",attrs:{"x-small":""},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();_vm.$router.push(`/tags/${tag.slug}/`).catch((err) => {
          _vm.$vuetify.goTo(0);
        })}}},[_vm._v(" "+_vm._s(tag.title)+" ")])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }